<main>
  <loading-overlay [isLoading]="isLoading() > 0"></loading-overlay>

  <header>
    <div>
      @if (labDip()) {
        <h1>{{ 'LabDips_Recipes_For' | translateWF: 'Recipes for Lab Dip' }}: {{ labDip()?.labDipNumber }}</h1>
        @if (labDip()?.colorDto?.name) {
          <p class="text-gray-600">{{ 'LabDips_Color' | translateWF: 'Color' }}: {{ labDip()?.colorDto?.name }}</p>
        }
      }
    </div>
    <div class="buttons">
      <p-button [label]="'Common_Back' | translateWF: 'Back'" icon="pi pi-arrow-left" variant="outlined" (click)="onCancel()" />
    </div>
  </header>

  <div class="content">
    @if (recipes().length === 0 && isLoading() === 0) {
      <div class="empty-state">
        <p>{{ 'LabDips_No_Recipes' | translateWF: 'No recipes found for this Lab Dip' }}</p>
        @if (canEdit()) {
          <p-button [label]="'LabDips_Create_Recipe' | translateWF: 'Create Recipe'" icon="pi pi-plus" (click)="onCreateNewRecipe()" />
        }
      </div>
    }

    @if (recipes().length > 0) {
      <div class="recipes-tabs-container">
        <p-panel>
          <p-card data-variant="compact">
            <p-tabs [value]="activeTabIndex" (valueChange)="onTabChange($event)">
              <p-tablist>
                @for (recipe of recipes(); track $index) {
                  <p-tab [value]="$index">
                    <div class="recipe-tab-content">
                      <span class="recipe-number">{{ recipe.recipeNumber }}</span>
                      @if (recipe.manufacturerLotNumberKeys && recipe.manufacturerLotNumberKeys.length > 0) {
                        <span class="recipe-lots">Lots: {{ formatLots(recipe.manufacturerLotNumberKeys) }}</span>
                      }
                    </div>
                  </p-tab>
                }
                @if (canEdit()) {
                  <p-tab [value]="recipes().length"> <i class="pi pi-plus"></i> {{ 'LabDips_New_Recipe' | translateWF: 'New Recipe' }} </p-tab>
                }
              </p-tablist>

              <p-tabpanels>
                @for (recipe of recipes(); track $index) {
                  <p-tabpanel [value]="$index">
                    <div class="recipe-content">
                      @if (selectedRecipeId() === recipe.id) {
                        <div class="recipe-info">
                          <div class="recipe-header">
                            <h2>{{ recipe.recipeNumber }}</h2>
                            @if (canEdit()) {
                              <div class="header-buttons">
                                <p-button [label]="'Common_Edit' | translateWF: 'Edit'" icon="pi pi-pencil" (click)="editRecipe(recipe.id!)" />
                                <p-button [label]="'Common_Duplicate' | translateWF: 'Duplicate'" icon="pi pi-copy" variant="outlined" (click)="duplicateRecipe(recipe.id!)" />
                              </div>
                            }
                          </div>

                          <div class="recipe-details-grid">
                            <div class="detail-item">
                              <label>{{ 'Liquor_Ratio' | translateWF: 'Liquor Ratio' }}</label>
                              <p>{{ recipe.liquorRatio }}</p>
                            </div>
                            <div class="detail-item">
                              <label>{{ 'Shade' | translateWF: 'Shade' }}</label>
                              <p>{{ getShade(recipe.shadeReference)?.name || recipe.shadeReference }}</p>
                            </div>
                            <div class="detail-item">
                              <label>{{ 'Created_Date' | translateWF: 'Created Date' }}</label>
                              <p>{{ recipe.createdDate | date: 'short' }}</p>
                            </div>
                            <div class="detail-item">
                              <label>{{ 'Created_By' | translateWF: 'Created By' }}</label>
                              <p>{{ recipe.createdBy }}</p>
                            </div>
                          </div>

                          @if (recipe.processSnapshots && recipe.processSnapshots.length > 0) {
                            {{ normalizeProcessSnapshots(recipe) }}
                            <div class="processes-section">
                              <h3>{{ 'Processes' | translateWF: 'Processes' }}</h3>
                              <app-process-details-table [processes]="recipe.processSnapshots" />
                            </div>
                          }

                          @if (recipe.manufacturerLotNumberKeys && recipe.manufacturerLotNumberKeys.length > 0) {
                            <div class="manufacturer-section">
                              <h3>{{ 'Manufacturer_Lot_Numbers' | translateWF: 'Manufacturer Lot Numbers' }}</h3>
                              <p-table [value]="recipe.manufacturerLotNumberKeys">
                                <ng-template pTemplate="header">
                                  <tr>
                                    <th>Fiber Code</th>
                                    <th>Manufacturer</th>
                                    <th>Lot Number</th>
                                    <th>Date Added</th>
                                  </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-mln>
                                  <tr>
                                    <td>{{ mln.fiberCode }}</td>
                                    <td>{{ getBusiness(mln.manufacturerReference)?.name || mln.manufacturerReference }}</td>
                                    <td>{{ mln.manufacturerLotNumber }}</td>
                                    <td>{{ mln.dateAdded | date: 'short' }}</td>
                                  </tr>
                                </ng-template>
                              </p-table>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </p-tabpanel>
                }

                <!-- Tab panel for creating new recipe -->
                @if (canEdit()) {
                  <p-tabpanel [value]="recipes().length">
                    <div class="empty-state">
                      <p>{{ 'LabDips_Create_New_Recipe_Message' | translateWF: 'Click the button below to create a new recipe' }}</p>
                      <p-button [label]="'LabDips_Create_Recipe' | translateWF: 'Create Recipe'" icon="pi pi-plus" (click)="onCreateNewRecipe()" />
                    </div>
                  </p-tabpanel>
                }
              </p-tabpanels>
            </p-tabs>
          </p-card>
        </p-panel>
      </div>
    }
  </div>
</main>
